export const isBlackWeek = () => {
  const today = new Date();
  const startDate = new Date("2025-11-24T00:00:00");
  const endDate = new Date("2025-11-30T23:59:59");

  return today >= startDate && today <= endDate;
};

export const SHOW_NEWSLETTER_BANNER = false;
